import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import Passengers from '../components/passenger/Passengers';


interface Props {
}

const PassengersScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <Passengers />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default PassengersScreen